import { DialogActions as MUIDialogActions, styled } from '@mui/material';
export const DialogActions = styled(MUIDialogActions) `
  ${({ theme }) => theme.breakpoints.up('xs')} {
    border-top: ${({ theme }) => `1px solid ${theme.palette.grey[300]}`};
  }

  padding: ${({ theme }) => theme.spacing(2)};
`;
